import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router'
import { Observable } from 'rxjs'
import { AlertService } from '@services/alert.service'
import { ToastService } from '@services/toast.service'
import { TranslateService } from '@ngx-translate/core'

@Injectable({
  providedIn: 'root'
})
export class DisableFormsGuard {
  constructor(
    private router: Router,
    private alertSvc: AlertService,
    private toastr: ToastService,
    private translate: TranslateService
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.alertSvc.disableForms()) {
      this.toastr.warning(this.translate.instant('errors.toasts.disableForms').message)

      return this.router.parseUrl('/etusivu')
    }

    return true
  }
}
